const PinnedLinkIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
      <g clipPath='url(#clip0_31667_154508)'>
        <path
          d='M5.00293 6.49998C5.21766 6.78705 5.49161 7.02457 5.8062 7.19645C6.1208 7.36833 6.46868 7.47054 6.82625 7.49615C7.18383 7.52176 7.54272 7.47017 7.8786 7.34487C8.21448 7.21958 8.51949 7.02352 8.77293 6.76998L10.2729 5.26998C10.7283 4.79848 10.9803 4.16697 10.9746 3.51148C10.9689 2.85599 10.706 2.22896 10.2425 1.76544C9.77896 1.30192 9.15192 1.03899 8.49643 1.0333C7.84094 1.0276 7.20944 1.27959 6.73793 1.73498L5.87793 2.58998M7.00303 5.50011C6.7883 5.21305 6.51435 4.97552 6.19975 4.80364C5.88516 4.63176 5.53728 4.52955 5.1797 4.50395C4.82213 4.47834 4.46324 4.52993 4.12736 4.65522C3.79148 4.78051 3.48647 4.97658 3.23303 5.23011L1.73303 6.73011C1.27763 7.20162 1.02565 7.83312 1.03134 8.48862C1.03704 9.14411 1.29996 9.77114 1.76348 10.2347C2.227 10.6982 2.85403 10.9611 3.50953 10.9668C4.16502 10.9725 4.79652 10.7205 5.26803 10.2651L6.12303 9.41011'
          stroke='#402080'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_31667_154508'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PinnedLinkIcon
